//手机发布页相关规则弹窗
export default {
  routes: [
    // 手机发布页弹窗
    {
      path: '/(\\s*)publishRules(\\d*)',
      name: 'publishRules',
      meta: {
        desc: '手机发布规则页'
      },
      component: () =>
        import(/* webpackChunkName: "publishRules" */ '../views/publishRules/index.vue')
    }
  ]
}
